import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  inputLabel: {
    '& .text, & b': {
      color: 'var(--text-primary)',
      fontSize: '13px',
      lineHeight: '19.56px',

      '@media screen and (min-width: 1441px)': {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },

    '& .text': {
      '& .viboIcon': {
        color: 'var(--text-secondary)',
        margin: '0 8px 0 0',
      },
    },

    '&.vertical': {
      display: 'grid',
      wordBreak: 'break-word',

      '& .text': {
        marginBottom: '6px',

        '@media screen and (min-width: 1441px)': {
          marginBottom: '12px',
        },
      },
    },

    '&.horizontal': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
    },
  },

  disabled: {
    color: 'var(--text-disabled)',
  },

  req: {
    color: 'var(--text-primary)',
  },
}));

export default useStyles;
